/**
 * Shared registry for listeners of type `L`. Managers extend this to own a listener collection
 * (add + iterate) without re-implementing the bookkeeping.
 */
export abstract class ListenerRegistry<Listener> {
  protected readonly listeners: Listener[] = []

  addListener(listener: Listener): void {
    this.listeners.push(listener)
  }
}
